function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.35;mix-blend-mode:multiply;fill:url(#linear-gradient);}.cls-3{fill:#fc0;}.cls-4{fill:#fcdc59;}.cls-5{fill:#da8100;}.cls-6{fill:#f0aa00;}.cls-7{fill:#ea9c00;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 23.39,
  y1: 69.72,
  x2: 146.12,
  y2: 69.72,
  gradientTransform: "translate(-24.29 57.34) rotate(-32.97)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#303030"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#5b5b5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#828282"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#a4a4a4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "silver"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#d8d8d8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#e9e9e9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#f6f6f6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#fdfdfd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Asset 3");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "OBJECTS"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 46.75,
  y: 15.54,
  width: 76,
  height: 108.35,
  transform: "translate(51.58 -34.89) rotate(32.97)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M102.26,51.13A51.13,51.13,0,1,1,51.13,0,51.13,51.13,0,0,1,102.26,51.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M90.25,18.22A51.13,51.13,0,0,0,2.88,68.05Q46.13,42.39,90.25,18.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M57,101.91A50.91,50.91,0,0,0,87.23,87.33c-8,3.84-16,7.72-23.92,11.58C61.23,99.92,59.13,100.91,57,101.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M89.19,50.32A38.87,38.87,0,1,1,50.32,11.45,38.87,38.87,0,0,1,89.19,50.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M90.29,51.94A38.35,38.35,0,1,1,51.94,13.59,38.35,38.35,0,0,1,90.29,51.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M47.78,79.06V72.28a19.47,19.47,0,0,1-10.27-3l1.61-4.5a17.92,17.92,0,0,0,9.67,2.89c4.77,0,8-2.76,8-6.58s-2.62-6-7.59-8c-6.85-2.69-11.08-5.78-11.08-11.62,0-5.57,4-9.8,10.14-10.81V23.94h4.16v6.51a17.89,17.89,0,0,1,8.73,2.35l-1.67,4.43A16.36,16.36,0,0,0,51,35c-5.17,0-7.11,3.09-7.11,5.77,0,3.49,2.48,5.24,8.32,7.66,6.92,2.82,10.41,6.31,10.41,12.29,0,5.3-3.69,10.27-10.61,11.41v7Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M48.72,78V71.22a19.66,19.66,0,0,1-10.27-3l1.61-4.5a17.92,17.92,0,0,0,9.67,2.88c4.77,0,8-2.75,8-6.58s-2.62-6-7.59-8c-6.85-2.68-11.08-5.77-11.08-11.61,0-5.58,4-9.81,10.14-10.81V22.88h4.16v6.51a17.86,17.86,0,0,1,8.73,2.35l-1.67,4.43a16.23,16.23,0,0,0-8.47-2.28c-5.17,0-7.11,3.09-7.11,5.77,0,3.49,2.48,5.24,8.32,7.66,6.92,2.82,10.41,6.31,10.41,12.28C63.56,64.91,59.87,69.88,53,71v7Z"
}))));

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 146.12 135.85",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Coins.abf441c9.svg";
export { ForwardRef as ReactComponent };